import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../../service/auth.service';
import {ApiService} from '../../service/api.service';
import {HttpParams} from '@angular/common/http';

import Swal from 'sweetalert2';
import {EnvironmentService} from '../../service/environment.service';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {

    submitted: boolean = false;
    constructor(private api: ApiService, private auth: AuthService, private activtedRoute: ActivatedRoute, private env: EnvironmentService) {
    }

    ngOnInit() {
        this.activtedRoute.queryParams.subscribe(
            (queryParams: Object) => {
                const body = new HttpParams().set('token', queryParams['token']);

                this.submitted = true;
                const baseUrl = this.env.getApiUrl().replace('private/clients/', '');
                this.api.getHttp().post(baseUrl + 'extranet/clients-auto-login', body).subscribe(
                    params => {
                        this.auth.initUser(params);
                        this.auth.setSource('backoffice');
                        this.submitted = false;
                    },
                    response => {
                        Swal('Auto login error', 'Unable to authenticate user by token', 'error');
                        this.submitted = false;
                    }
                );
            }
        )
    }


}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/auto-login/auto-login.component.ts